"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNil = void 0;
function isNil(value) {
    return value === null || value === undefined;
}
exports.isNil = isNil;
//# sourceMappingURL=is-nil.js.map